module.exports = __webpack_public_path__ + "static/media/assistance_type_battery.99ad26bf.svg";